module.exports = __webpack_public_path__ + "app/announcement/announcement-details-drh-JBi_.html";